import styled from "styled-components";
import { theme } from "../../../../helpers/theme";
import { ReactComponent as AdImgSVG } from "../../../../assets/icons/adImg.svg";
import Icon from "../../../../components/icon";
import adImg from "../../../../assets/icons/adImg.svg";

const AdSection = () => {
  return (
    <>
      <AdSec>
        <AdText>Zautomatyzowane oferty magazynowe - szybciej, łatwiej, skuteczniej</AdText>
        <AdImgContainer>
          <Icon icon={<AdImgSVG />} />
        </AdImgContainer>
        {/* <AdImg src={adImg} /> */}
        <AdSmallTextsContainer>
          <AdSmallTextContainer>
            <AdSmallTextBar />
            <AdSmallText>
            Optymalizacja kosztów: system umożliwia skuteczne zarządzanie przestrzenią
            </AdSmallText>
          </AdSmallTextContainer>
          <AdSmallTextContainer>
            <AdSmallTextBar />
            <AdSmallText>
            Szybkość i efektywność: automatyzacja procesu generowania ofert oraz natychmiastowa 
weryfikacja dostępności magazynów za pomocą API 
            </AdSmallText>
          </AdSmallTextContainer>
          <AdSmallTextContainer>
            <AdSmallTextBar />
            <AdSmallText>
            Elastyczność i skalowalność: możliwość korzystania z wielu magazynów na raz pozwala na łatwą 
skalowalność w miarę rozwoju biznesu
            </AdSmallText>
          </AdSmallTextContainer>
          <AdSmallTextContainer>
            <AdSmallTextBar />
            <AdSmallText>
            Optymalizacja: dzięki systemowi rozproszonemu, możliwe jest optymalizowanie trasy transportu i 
minimalizowanie emisji dwutlenku węgla
            </AdSmallText>
          </AdSmallTextContainer>
        </AdSmallTextsContainer>
      </AdSec>
    </>
  );
};

export default AdSection;

const AdSec = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -5px;
  margin-bottom: 37.5px;
  justify-content: space-between;
  @media ${theme.device.laptop} {
    flex-direction: row;
    margin-bottom: 130px;
  }
`;

const AdTextContainer = styled.div`
  z-index: 2000;
`;

const AdText = styled.p`
  font-family: ${theme.fonts.interRegular};
  font-weight: 700;
  font-size: 22.5px;
  // line-height: 112%;
  width: min-content;
  // height: 216px;
  margin-block: 0;
  margin-bottom: 50px;

  @media ${theme.device.tablet} {
    font-size: 30px;
  }

  @media ${theme.device.laptop} {
    font-size: 48px;
    line-height: 112%;
  }
<<<<<<< HEAD
`;

const AdTextBar = styled.div`
  width: 100%;
  height: 15px;
  background-color: ${theme.colors.white};
  position: relative;
  // left: -30px;
  top: 72px;
  z-index: -1;
  
  @media ${theme.device.tablet} {
    top: 119px;
    height: 20px;
  }
  
  @media ${theme.device.laptop} {
    top: 145px;
    height: 28px;
  }
=======
>>>>>>> f462c80291804683826ba3fe0385d3597dc476b3
`;

const AdImg = styled.img`
  margin-left: 45px;
  display: none;
  height:80%;

  @media ${theme.device.laptopL} {
    display: block;
  }
`;
const AdImgContainer = styled.div`
  margin-left: 45px;
  display: none;

  @media ${theme.device.laptopL} {
    display: block;
  }
`;

const AdSmallTextsContainer = styled.div`
  width: fit-content;
  max-width: 65%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 0;
  align-items: center;

  @media ${theme.device.mobileL} {
    flex-direction: row;
  }

  @media ${theme.device.laptop} {
    margin-top: 3rem;
    justify-content: space-between;
    max-width: 40%;
  }
`;

const AdSmallTextContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;

  @media ${theme.device.mobileL} {
    width: 45%;
  }

  @media ${theme.device.tablet} {
    width: 40%;
  }
`;

const AdSmallText = styled.p`
  font-family: ${theme.fonts.interMedium};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  margin-block: 0;
`;

const AdSmallTextBar = styled.div`
  min-width: 4px;
  height: 30px;
  background: ${theme.colors.blue01_active};
  border-radius: 2px;
  margin-right: 24px;
`;
